import { intlLocaleOf, type Locale } from "@/shared/i18n/messages";

/** "A, B and C" / "A وB وC": items joined the way the locale writes a list. */
export function formatList(items: readonly string[], locale: Locale): string {
  return new Intl.ListFormat(intlLocaleOf(locale), { style: "long", type: "conjunction" }).format(
    items,
  );
}
